var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIconBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_297_7085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.45033 7.04448V6.26508C6.45033 4.71913 7.19444 3.59334 8.70511 3.59334C10.3633 3.59334 11.0272 4.62932 11.0272 6.26508V7.04448H6.45033ZM2.14283 16.8205V8.70269C2.14283 8.51024 2.29037 8.37554 2.46998 8.37554H14.998C15.1776 8.37554 15.3347 8.51024 15.3347 8.70269V16.8205C15.3347 17.0002 15.1776 17.1477 14.998 17.1477H2.46998C2.29037 17.1477 2.14283 17.0002 2.14283 16.8205ZM0.811768 16.8205C0.811768 17.7346 1.55588 18.4788 2.46998 18.4788H14.998C15.9217 18.4788 16.6658 17.7346 16.6658 16.8205V8.70269C16.6658 7.78859 15.9217 7.04448 14.998 7.04448H14.4688V6.30999C14.4655 2.64396 12.4385 0.142212 8.75001 0.142212H8.72756C5.02946 0.142212 3.01202 2.64396 3.01202 6.30999V7.04448H2.46998C1.55588 7.04448 0.811768 7.78859 0.811768 8.70269L0.811768 16.8205ZM13.1473 6.30999V7.04448H12.3583V6.26508C12.3583 3.87559 11.0721 2.26228 8.70511 2.26228C6.33807 2.26228 5.11927 4.01992 5.11927 6.26508V7.04448H4.33025V6.30999C4.33025 3.356 5.80885 1.47327 8.74039 1.47327C11.6719 1.47327 13.1505 3.41373 13.1505 6.30999H13.1473Z",
    fill: "#1B1A1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_7085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.854,
    height: 18.3333,
    fill: "white",
    transform: "translate(0.811768 0.142212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconBlank);
export default __webpack_public_path__ + "static/media/lock-icon-blank.919304e8273cba0ecb8ab3ca31c65168.svg";
export { ForwardRef as ReactComponent };